import {requirePermission} from '@/modules/auth/permissions'
import {BatchForm} from '@/modules/stocks/batches/components/batch-form/batch-form'
import {NewBatchSearchSchema} from '@/modules/stocks/batches/schemas'
import {useManualEntryBlocked} from '@/shared/hooks/use-manual-entry-flags'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute, redirect} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/stocks/batches/new')({
  beforeLoad: requirePermission('stock.manage'),
  component: NewBatchPage,
  validateSearch: NewBatchSearchSchema,
})

function NewBatchPage() {
  const {t} = useTranslate('common')
  const {batchId} = Route.useSearch()
  const {manualStockBlocked} = useManualEntryBlocked()
  if (manualStockBlocked && !batchId) throw redirect({to: '/stocks/batches'})

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={batchId ? t('edit_stock_title') : t('new_stock_title')}
        description={t('new_stock_description')}
      />
      <BatchForm batchId={batchId} />
    </NewResourceFormContainer>
  )
}
